const prototypeStockRouter = {
  title: '样机仓储',
  type: 'view',
  name: Symbol('prototypeStock'),
  route: '/product/prototypeStock',
  filePath: 'view/product/jz_productPrototypeStock.vue',
  inNav: false,
  icon: 'iconfont icon-yangji',
  sortId: 99,
}

export default prototypeStockRouter